<template lang="pug">
    .flex
      .aprovacao-problema.three-columns(v-if="problema")
        .aprovacao-problema__icone
          span.icon-ptt-icons-alerta.color-warning.fs-19
        .aprovacao-problema__legendas
          div.observacao {{problema.observacao}}
          div.detalhes {{problema.detalhes}}

      .two-columns
        DBLabel(:body="status" title="status:" :loading="loading")
        DBLabel(:body="approval.ruleSourceName" title="regra de aprovação:" :loading="loading")
      .two-columns
        DBLabel(:body="approval.employeeName" :title="`${$ws('employee')}:`")
        DBLabel(:body="approval.company" title="local de trabalho:")
      .two-columns
        DBLabel(:body="approval.typeView" title="evento:")
        DBLabel(:body="approval.date" title="data do evento:")

      .info
        template(v-if="apontamento")
          DBLabel(title="informação:")
          TimeMeasurements(:line='approval.info')

        template(v-else)
          DBLabel(:body="info" title="informação:")

      .reason
        DBLabel(:body="motivoEvento" title="motivo do evento:")
        a(v-if="approval.info && approval.info.imgLink", target="_blank", :href="approval.info.imgLink", title="ver atestado anexado") ver atestado anexado

      .two-columns
        DBLabel(v-if="naoPendente" :body="aprovadoPor" :title="adjetivoAprovacao +  ' por: '" :loading="loading")
        DBLabel(v-if="naoPendente" :body="aprovadoEm" :title="adjetivoAprovacao +  ' em: '" :loading="loading")

      .reason(v-if="approval.approvalReason")
        DBLabel(:body="approvalReason" :title="'motivo da ' + substantivoAprovacao + ':'" :loading="loading")

      Flipper(:currentView="approveShow.show ? 1 : 0")
        template(v-slot:front)
          .buttons
            PButton(v-if="autoAprovacao" color="info" size="md" @click="isAware(approval)" :loading="loading")
              span ciente
            PButton(v-if="showReprove(approval)" color="danger" size="md" @click="showApprovalRequest(approval, 'reprove')" :loading="loading")
              span.icon-ptt-icons-reprovar
            PButton(v-if="showApprove(approval)" color="success" size="md" @click="showApprovalRequest(approval, 'approve')" :loading="loading")
              span.icon-ptt-icons-aprovar

        template(v-slot:back)
          .form-approve
            PTextField(v-model="approveShow.comment" label="motivo" name="motivo")
            PButton(color="danger" size="md" @click="cancelApprove" block) cancelar
            PButton(color="success" size="md" @click="updateApprovalRequest" block :loading="loading") salvar
</template>

<script>
import moment from 'moment'
import TimeMeasurements from './ApprovalsComponents/ApprovalsTms.vue'
import Flipper from 'src/common/transitions/Flipper'
import { pegarMensagemDoProblemaDetalhes } from './utils.js'

export default {
  name: 'ApprovalDetails',
  components: { TimeMeasurements, Flipper },
  props: {
    approval: {required: true, type: Object},
    loading: {required: true, type: Boolean}
  },
  data () {
    return {
      approveShow: {
        show: false,
        comment: '',
        kind: '',
        approval: null
      }
    }
  },
  computed: {
    problema () {
      return pegarMensagemDoProblemaDetalhes(this.approval)
    },
    status () {
      const status = this.approval.approved
      if (status === true) {
        return 'aprovado'
      } else if (status === false) {
        return 'reprovado'
      } else {
        return 'pendente'
      }
    },
    motivoEvento () {
      const reason = this.approval
      if (!reason.employeeReason) {
        if (reason.typeView === 'Correção de ponto') {
          return reason.info.justificativa
        } else if (reason.typeView === 'Apontamento') {
          return 'Apontamento gerado de acordo com as horas trabalhadas'
        } else {
          return '-'
        }
      } else {
        return reason.info.reason || reason.employeeReason
      }
    },
    naoPendente () {
      return this.approval.approvedAt && this.approval.approvedAt !== ''
    },
    apontamento () {
      return this.approval.typeView === 'Apontamento'
    },
    info () {
      const item = this.approval
      if (item.info) {
        if (item.typeView === 'Correção de ponto') {
          return item.info.kind + ' às ' + item.info.time
        } else if (item.typeView === 'Dispensa') {
          if (item.info.allDay) {
            return 'Dispensa para o dia inteiro'
          } else {
            if (item.info.startTime) {
              return 'Disp. parcial das ' + this.formatHour(item.info.startTime) + ' às ' + this.formatHour(item.info.endTime)
            } else if (item.info.duration) {
              return 'Disp. parcial com ' + item.info.duration + ' horas de duração'
            } else {
              return 'Dispensa parcial'
            }
          }
        }
      }
      return ''
    },
    approvalReason () {
      const reason = this.approval
      if (!reason.approvalReason) {
        return '-'
      } else {
        return reason.approvalReason
      }
    },
    aprovadoPor () {
      if (this.approval.approvedBy === 'Autoapprovação') {
        return 'Aprovação Automática'
      } else {
        return this.approval.approvedBy
      }
    },
    aprovadoEm () {
      return this.formatDate(this.approval.approvedAt)
    },
    adjetivoAprovacao () {
      return this.approval.approved ? 'aprovado' : 'reprovado'
    },
    substantivoAprovacao () {
      return this.approval.approved ? 'aprovação' : 'reprovação'
    },
    autoAprovacao () {
      return (this.approval.approvedBy === 'Autoapprovação' || this.approval.approvedBy === 'Aprovação Automática') && !this.approval.isAware
    }
  },
  methods: {
    pedidoEstaReprovado (aprovacao) {
      // regra pra não deixar aprovar se já foi reprovado
      return aprovacao.approved === false
    },
    pedidoEstaAprovado (aprovacao) {
      // regra pra não deixar aprovar se já foi reprovado
      return aprovacao.approved === true
    },
    pedidoEstaPendente (aprovacao) {
      // regra pra não deixar aprovar se já foi reprovado
      return aprovacao.approved === null
    },
    formatHour (hour) {
      return moment(hour).format('HH:mm')
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    showApprove (aprovacao) {
      return this.pedidoEstaPendente(aprovacao)
      // comentado pois a regra sugerida é que não será possível aprovar algo que já foi reprovado
      // return (this.pedidoEstaPendente(aprovacao) || this.pedidoEstaReprovado(aprovacao))
    },
    showReprove (aprovacao) {
      return (this.pedidoEstaPendente(aprovacao) || this.pedidoEstaAprovado(aprovacao))
    },
    cancelApprove () {
      this.approveShow = {show: false, kind: '', comment: '', approval: ''}
    },
    showApprovalRequest (approval, kind) {
      this.approveShow = {
        kind: kind,
        comment: '',
        show: true,
        approval: approval
      }
    },
    async updateApprovalRequest () {
      if (this.approveShow.kind === 'reprove' && this.approveShow.comment === '') {
        this.$swal({
          type: 'error',
          text: 'É preciso informar um motivo para reprovar um evento'
        })
        return
      }

      this.loading = true
      const params = {
        approvsIds: [this.approveShow.approval.id],
        approved: this.approveShow.kind === 'approve',
        approvalComment: this.approveShow.comment,
        force: true
      }

      try {
        const result = await this.$API.approveLines.save(params)
        if ('success' in result.body) {
          this.$modalDeSucesso(result?.data?.success ? result.data.success : 'Operação realizada com sucesso!')
        } else {
          this.$modalDeErro(result?.data?.error ? result.data.error : 'Não foi possível efetuar essa operação')
        }
      } catch (e) {
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível efetuar essa operação')
      }
      this.cancelApprove()
      this.loading = false
      this.$emit('updateTable', true)
    },
    async isAware (approval) {
      const params = {
        approvsIds: [approval.id],
        approved: approval.approved,
        approvalComment: 'Estou ciente desse evento',
        isAware: true,
        force: true
      }
      const result = await this.$API.approveLines.save(params)
      if ('success' in result.body) {
        this.$emit('updateTable', true)
      } else {
        this.$swal({
          type: 'error',
          text: result.body?.error ? result.body.error : 'Não foi possível efetuar essa operação'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.flex {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 11px;

  .buttons {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: min-content min-content min-content;
    grid-column: 1;
    grid-auto-flow: column;
  }

  .form-approve {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 0.3fr 0.3fr;
    grid-column: 1;
    grid-auto-flow: column;
  }
}

.two-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column: 1/4;
  grid-column-gap: 30px;
  margin-bottom: 12px;
}

.three-columns {
  display: grid;
  grid-column: 1/4;
  grid-column-gap: 30px;
  margin-bottom: 12px;
}

.aprovacao-problema {
  display: grid;
  grid-template-areas: "icone legendas";
  grid-auto-flow: column;
  grid-template-columns: 2rem auto;
  width: calc(100% - 3rem);
  align-items: center;
  justify-items: flex-start;
  border: 0.25rem solid var(--color-warning);
  padding: 1rem;
}

.aprovacao-problema__legendas {
  grid-area: legendas;
}

.aprovacao-problema__icone {
  width: 2rem;
  height: 2rem;
  margin-right: -1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-area: icone;
}

.aprovacao-problema__legendas .observacao {
  font-size: 1.2em;
}

.aprovacao-problema__legendas .detalhes {
  font-size: 0.8em;
  font-weight: bold;
}

.reason {
  display: grid;
  grid-template-columns: 2fr;
  grid-column: 1/4;
  margin-bottom: 12px;
}

a {
  text-decoration: underline;
}

</style>
